import React from 'react';
import './ContentSection.css';

const contentList = [
    { text: 'Deine Emotionen überwältigen dich und du weißt oft nicht, wie du mit ihnen umgehen sollst?', icon: true },
    { text: 'Du fühlst dich innerlich leer, erschöpft und energielos?', icon: true },
    { text: 'Du zweifelst an dir, kämpfst mit dem Gefühl "nicht gut" genug zu sein?', icon: true },
    { text: 'Du bleibst in Verbindungen, die dir nicht gut tun, aus Angst alleine zu sein?', icon: true },
    { text: 'Du hast das Gefühl, niemand versteht dich wirklich und du trägst alles allein mit dir?', icon: true },
    { text: 'Es fällt dir schwer, klare Entscheidungen zu treffen - weil du gar nicht mehr weißt was du selbst willst?', icon: true },
    { text: 'In dir wächst der Wunsch, dich endlich selbst zu finden - jenseits von Erwartungen und alten Mustern?', icon: true },
    { text: 'Dann bist du hier genau richtig!', icon: false, special: true },
    { text: 'Mit Techniken aus NLP, Hypnose und Energiearbeit lösen wir alte Muster, stärken deine Selbstwahrnehmung und bauen neue innere Klarheit auf.', icon: false, special3: true },
    { text: 'Du lernst, Grenzen zu setzen, dich selbst zu halten und bewusst mit deinen Gefühlen umzugehen.', icon: true },
    { text: 'Du findest in dein Gleichgewicht - mit mehr Selbstvertrauen, inneren Frieden und echter Selbstbestimmung.', icon: true },
    { text: 'Deine Emotionen sind kein Hindernis - sie sind der Schlüssel. Selbstführung beginnt dort, wo du lernst, sie zu verstehen, zu halten und zu verwandeln.', icon: false, special2: true },
  ];

  const ContentSection = () => (
    <section className="content-section">
      <ul className="content-list">
        {contentList.map((item, index) => (
          <li
          key={index}
          className={`content-list-item ${item.special ? 'special' : ''} ${item.special2 ? 'special2' : ''} ${!item.icon ? 'no-icon' : ''}`}
            >
            {item.icon && <img src={require('../assets/images/logotrkl4.png')} alt="Logo" className="list-icon" />}
            <span className="list-text">{item.text}</span>
          </li>
        ))}
      </ul>
    </section>
  );

export default ContentSection;